import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { DriverService } from '@core/services/driver.service';
import { ParkingLot } from '@core/models/parking-manager.model';
import { CompanyService, BreadcrumbItem } from 'src/app/shared/services/company.service';
import { SuperAdminService } from '@core/services/super-admin.service';
import { CountryISO, PhoneNumberFormat, SearchCountryField } from "ngx-intl-tel-input-gg";
import { HttpErrorResponse } from '@angular/common/http';
import { ToastService } from 'src/app/shared/services/toast.service';
import { DatePipe} from '@angular/common';
import { CustomValidator } from 'src/app/shared/services/custom-validatior.abstract';
import { MenuService } from '@core/services/menu.service';
import { ARRIVAL_DEPARTURE_GREATERTIME, DECIMAL_VALIDATION_PATTERN, USER_ROLES } from '@shared/constant/shared.constant';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { CommonConfirmationModalComponent } from '@shared/components/common-confirmation-modal/common-confirmation-modal.component';
import { autoUnsubWith, Utility } from '@shared/services/utility.abstract';
import { CommonFunctions } from '@shared/common-functions';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';

@Component({
  selector: 'app-one-time-invoice',
  templateUrl: './one-time-invoice.component.html',
  styleUrls: ['./one-time-invoice.component.scss']
})
export class OneTimeInvoiceComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  value: string | undefined;
  minDepartureDate: Date | null = null;
  parkingCount: number;
  selectedParkingLot: any;
  parkingLots: ParkingLot[];
  companyId: string;
  parkingDetail: any;
  dummy = "assets/images/Profile_Account_logo.svg";
  itemForm: FormGroup;
  driverId: string;
  searchCountryField = SearchCountryField;
  countryISO: CountryISO = CountryISO.UnitedStates;
  phoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  driverDetails: any;
  separateDialCode = false;
  parkingLotId: string;
  isInvoiceShare: boolean = false;
  maxDate: Date;
  filteredemail: any[] = [];
  overallTotal: number = 0
  roleName: string;
  roleRoute: string;
  driverEmailIdReadOnly: false;
  isShow : boolean = false

constructor(
    private readonly superAdminService: SuperAdminService,
    private readonly driverService: DriverService,
    private readonly route: ActivatedRoute,
    private readonly companyService: CompanyService,
    private readonly fb: FormBuilder,
    private readonly menuService: MenuService,
    private readonly toastService: ToastService,
    private readonly dialogControlService: DialogControlService,
    private readonly datePipe : DatePipe,
    private readonly encryptStorage: EncryptionStorageService  ) {

  }

  ngOnInit(): void {
    this.buildForm();
    this.maxDate = new Date();
    this.roleName = this.encryptStorage.getItem('roleName');
    this.routeToInvoiceList();
    this.route.params.subscribe((params: Params) => {
      const breadcrumbObj: BreadcrumbItem[] = [
        { title: 'Manage Invoices' },
        { title: 'Create Custom Invoice' }
      ];

      this.companyId = params['id'];
      this.companyService.setAdminHeaders(this.companyId, breadcrumbObj);
      this.getParkingLotByStatesName(this.companyId)
    });
    this.driverId = this.encryptStorage.getItem('driverId');
    const state = history.state;
    this.driverId = state.driverId || this.driverId;
    this.driverEmailIdReadOnly = state.emailId;
    if (this.driverId) {
      this.getUserDetailById(this.driverId);
    }
    if (state && state.parkingLotId) {
      this.getParkingDetailById(state.parkingLotId);
    }
  }

  get parkingLotInvoiceItems(): FormArray {
    return this.itemForm.get('parkingLotInvoiceItems') as FormArray;
  }

  addItem() {
    if (this.itemForm.get('parkingLotInvoiceItems').valid) {
      this.parkingLotInvoiceItems.push(this.createItem());
    }
    else {
      CustomValidator.markFormGroupTouched(this.itemForm)
    }
  }

  removeItem(index: number) {
    if (this.parkingLotInvoiceItems.length > 1) {
      this.parkingLotInvoiceItems.removeAt(index);
      this.calculateOverallTotal()
    }

  }
  shareInvoice() {
    this.itemForm.get('isInvoiceShare')?.setValue(!this.itemForm.get('isInvoiceShare')?.value);
  }
  buildForm() {
    this.itemForm = this.fb.group({
      name: ['', Validators.required],
      email: [''],
      phoneNumber: [''],
      address: [''],
      billingDate: ['', Validators.required],
      parkingLotId: [this.parkingLotId, Validators.required],
      driverId: [this.driverId],
      isInvoiceShare: [this.isInvoiceShare],
      parkingLotInvoiceItems: this.fb.array([this.createItem()]),
      invoicePaymentStatus: [null,[ Validators.required]],
      arrivalDate : [null],
      departureDate : [null],
    });
  }

createItem(): FormGroup | void {
    return this.fb.group({
      itemName: ['', Validators.required],
      baseAmount: ['', [Validators.required, Validators.pattern(DECIMAL_VALIDATION_PATTERN)]],
      taxPercent: ['',Validators.pattern(DECIMAL_VALIDATION_PATTERN)],
      feesPercent: ['',Validators.pattern(DECIMAL_VALIDATION_PATTERN)],
      totalAmount: [0,Validators.required],
    });

  }
  getUserDetailById(driverId): void {
    this.superAdminService.getUserDetailsById(driverId)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response) => {
        this.driverDetails = response;
        if (!this.itemForm.value.email && this.itemForm.value.phoneNumber) {
          this.patchFormWithMobile(this.driverDetails);
        } else {
          this.patchForm(this.driverDetails);
        }   
      }
    });
  }
  patchFormWithMobile(driverDetails: any): void {
    if (driverDetails) {
      this.itemForm.patchValue({
        phoneNumber: driverDetails.mobileNumber || '',
        email: driverDetails.email || '',
        name: driverDetails.role === USER_ROLES.GROUP_USER ? driverDetails.groupName : driverDetails.name,
      });
      
    }
  }

  patchForm(driverDetails: any): void {
    if (driverDetails) {
      const formattedAddress = [
        driverDetails.address,
        (driverDetails.city && driverDetails.zipCode) 
          ? `${driverDetails.city} ${driverDetails.zipCode}` 
          : driverDetails.city || driverDetails.zipCode,
        driverDetails.country
      ]        .filter(Boolean)
        .join(', '); 
      this.countryISO = driverDetails.iso,
        this.itemForm.patchValue({
          email: driverDetails.email || '',
          name: driverDetails.role === USER_ROLES.GROUP_USER ? driverDetails.groupName : driverDetails.name,
          phoneNumber: driverDetails.mobileNumber || '',
          address :  formattedAddress.trim().replace(/^,|,$/, '') 
        });
      
    }

  }
  setInvoicePaymentStatus(status: number): void {
    this.itemForm.get('invoicePaymentStatus')?.setValue(status);
  }

  getParkingLotByStatesName(id: string): void {
    this.parkingDetail = {}
    this.superAdminService.getParkingLotByStatesName(id)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response) => {
        this.parkingCount = response.length;
        this.selectedParkingLot = response[0]?.id;
        this.parkingLots = response;
        
        if (this.parkingCount === 1) {
          this.setDefaultParkingLot()
        }
      },
      error: () => {
        this.parkingLots = []
        
      }
    });
  }

  setDefaultParkingLot(): void {
    this.itemForm.get('parkingLotId')?.setValue(this.parkingLots[0].id);
    this.getParkingDetailById(this.parkingLots[0].id)
  }
  getParkingDetailById(id: string): void {
    
    this.parkingLotId = id;
    this.itemForm.get('parkingLotId')?.setValue(id);
    this.driverService.getparkingDetailById(id)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: response => {
        this.parkingDetail = response;
        const convertedDate = CommonFunctions.convertTimeBetweenZones(this.parkingDetail.timeZone, new Date());
        this.maxDate = new Date(convertedDate);
        const billingDateValue = this.itemForm.get('billingDate')?.value;
        if (billingDateValue) {
          const convertedbillingDate = CommonFunctions.convertTimeBetweenZones(this.parkingDetail.timeZone, new Date(billingDateValue));

if (convertedbillingDate > convertedDate ) {
            this.itemForm.get('billingDate')?.setValue(convertedDate);
          }
        }
        if(this.itemForm.get('arrivalDate')?.value){
          const arrivalDate = new Date(this.maxDate);
          arrivalDate.setMinutes(0, 0, 0);
          this.itemForm.get('arrivalDate')?.setValue(arrivalDate);
          
          const departureDateValue = this.itemForm.get('departureDate')?.value;
          if (departureDateValue) {
            const convertedDeparture = CommonFunctions.convertTimeBetweenZones(
              this.parkingDetail.timeZone,
              new Date(departureDateValue)
            );
            convertedDeparture.setMinutes(0,0,0)
            this.itemForm.get('departureDate')?.setValue(new Date(convertedDeparture));
          }
        }

},
      error: () =>{ 
        this.parkingDetail = {}
      }
    });
  }
  toggleShow() {
    this.isShow = !this.isShow
    const arrivalDateControl = this.itemForm.get('arrivalDate');
    const departureDateControl = this.itemForm.get('departureDate');

    if (this.isShow) {
      arrivalDateControl?.setValidators(Validators.required);
      departureDateControl?.setValidators(Validators.required);
    } else {
      arrivalDateControl?.clearValidators();
      departureDateControl?.clearValidators();
    }

    arrivalDateControl?.updateValueAndValidity();
    departureDateControl?.updateValueAndValidity();
    this.itemForm.updateValueAndValidity();
  }

  generateInvoice(): void {
    if (this.itemForm.invalid) {
      CustomValidator.markFormGroupTouched(this.itemForm);
      this.toastService.showToastMessage('error', 'Error', 'Please fill all mandatory fields.');
      return;
    }
    const toBeConvertedArrivalDate = this.itemForm.get('arrivalDate')?.value;
    const toBeConvertedDepartureDate = this.itemForm.get('departureDate')?.value;
    const startDate = toBeConvertedArrivalDate ? CommonFunctions.formatDateTime(toBeConvertedArrivalDate,toBeConvertedArrivalDate.getHours()) : null;
    const endDate = toBeConvertedDepartureDate ? CommonFunctions.formatDateTime(toBeConvertedDepartureDate,toBeConvertedDepartureDate.getHours()) : null;
    if (startDate && endDate && this.isShow) {
      if (startDate >= endDate) {
        this.toastService.showToastMessage('error', 'Error', ARRIVAL_DEPARTURE_GREATERTIME);
        return;
      }
    }
    this.dialogControlService.openDialog(CommonConfirmationModalComponent,{
      width: '25%',
      data: {
        headerText: 'Confirmation',
        bodyText: 'Are you sure you have reviewed all the details?',
        successIcon: true,
        errorIcon: false
      }
    });
    if(!this.isShow){ 
      this.itemForm.get('arrivalDate')?.setValue(null);
      this.itemForm.get('departureDate')?.setValue(null);
    }
    this.dialogControlService.onClose().subscribe((confirmed) => {
      if (confirmed) {
        
        const timeZone = Utility.getLocalTimeZone();
        this.itemForm.value.billingDate =
          this.datePipe.transform(this.itemForm.get('billingDate')?.value, 'yyyy-MM-dd') || '';
        this.itemForm.value.parkingLotId = this.parkingLotId;
        this.itemForm.value.driverId = this.driverId;
        this.itemForm.value.parkingLotInvoiceItems.rate = 0;
        this.itemForm.value.parkingLotInvoiceItems.quantity = 0;
        this.itemForm.value.parkingLotInvoiceItems[0].baseAmount = Number(this.itemForm.value.parkingLotInvoiceItems[0].baseAmount);
        this.itemForm.value.parkingLotInvoiceItems[0].taxPercent = Number(this.itemForm.value.parkingLotInvoiceItems[0].taxPercent);
        this.itemForm.value.parkingLotInvoiceItems[0].feesPercent = Number(this.itemForm.value.parkingLotInvoiceItems[0].feesPercent);
        this.itemForm.value.timeZone = timeZone;
        this.itemForm.value.arrivalDate = startDate;
        this.itemForm.value.departureDate = endDate;

        this.driverService.createParkingLotInvoiceForDriver(this.itemForm.value)
        .pipe(autoUnsubWith(this.destroyRef))
        .subscribe({
          next: (_response) => {
            this.toastService.showToastMessage('success', 'Success', _response.message);
            setTimeout(() => {
              
              localStorage.removeItem('driverId');
              this.menuService.redirectionTo(
                this.menuService.shortNameExists(JSON.parse(this.encryptStorage.getItem('menuData')), 86),
                `${this.roleRoute}/invoice-list?tab=1`
              );
            }, 1000);
          },
          error: (er: HttpErrorResponse) => {
            this.toastService.showToastMessage('error', 'Error', er.error.message);
            
          },
        });
      }
    });
  }

  calculateTotalAmount(index: number) {
    const baseAmount = parseFloat(this.parkingLotInvoiceItems.at(index).get('baseAmount')?.value || 0);
    const taxes = parseFloat(this.parkingLotInvoiceItems.at(index).get('taxPercent')?.value || 0);
    const fees = parseFloat(this.parkingLotInvoiceItems.at(index).get('feesPercent')?.value || 0);
    const addAllAmount =( baseAmount + taxes + fees);
    this.parkingLotInvoiceItems.at(index).patchValue({ totalAmount: addAllAmount });
    this.calculateOverallTotal();
  }

  calculateOverallTotal() {
    this.overallTotal = this.parkingLotInvoiceItems.controls.reduce((acc, curr) => {
      const totalAmount = parseFloat(curr.get('totalAmount')?.value || '0');
      return acc + totalAmount;
    }, 0);
    this.overallTotal = parseFloat(this.overallTotal.toFixed(2));

  }
  routeToInvoiceList() {
    this.roleRoute = (this.roleName === USER_ROLES.SUPER_ADMIN ? 'super-admin' : 'manager');
  }
  findEmail(event) {
    const searchEmail = event.query;
    const req: any = { searchEmail,searchMobileNumber:'' };

    this.superAdminService.getUserByEmailId(req)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (res: any) => {
        if (Array.isArray(res)) {
          this.filteredemail = res.map(response => ({
            email: response.email,
            id: response.id
          }));
        }

      },
      error: (_er: HttpErrorResponse) => {
        this.filteredemail = [];
        this.filteredemail = [{
          email: _er.error.message
        }];
      }
      });
  }
  onSelectionChange(res: any) {
    if (res.email === 'No Parker exists with this Email/Mobile Number.') {
      this.itemForm.patchValue({ email: '', phoneNumber: '' });
      this.itemForm.get('phoneNumber')?.enable();
    } else {
      this.driverId = res.id;
      this.itemForm.patchValue({ email: res.email });
      this.itemForm.get('phoneNumber')?.disable();
      this.getUserDetailById(this.driverId);
    }
  }
  onInputChange(_event) {  
  this.itemForm.patchValue({ name: '', phoneNumber: '' });
  this.itemForm.get('phoneNumber')?.enable();
  }

  validateNumberInput(event: KeyboardEvent, maxBeforeDecimal: number, allowDecimal: boolean = true): void {
    const inputElement = event.target as HTMLInputElement;
    const currentValue = inputElement.value;
    const caretPosition = inputElement.selectionStart || 0;
    if (!/[\d.]/.test(event.key) || (event.key === '.' && (!allowDecimal || currentValue.includes('.')))) {
      event.preventDefault();
      return;
    }
    const newValue = currentValue.slice(0, caretPosition) + event.key + currentValue.slice(caretPosition);
    const regex = allowDecimal
      ? new RegExp(`^\\d{0,${maxBeforeDecimal}}(\\.\\d{0,2})?$`)
      : new RegExp(`^\\d{0,${maxBeforeDecimal}}$`); 
    if (!regex.test(newValue)) {
      event.preventDefault();
    }
  }
  
  limitInputLength(controlName: string): void {
    const control = this.itemForm.get(controlName);
    if (control?.value) {
      const value = control.value.toString();
      const regex = /^\d{1,2}(\.\d{0,2})?$/;
  
      if (!regex.test(value)) {
        const trimmedValue = value.match(/^\d{0,2}(\.\d{0,2})?/);
        control.setValue(trimmedValue ? trimmedValue[0] : '');
      }
    }
  }
  
  onlyNumberInputs(event: KeyboardEvent): void {
    const allowedChars = /[0-9\.]/;
    if (!allowedChars.test(event.key)) {
      event.preventDefault();
    }
  }

    onlyNumberInput(event: KeyboardEvent): void {
    CommonFunctions.onlyNumberInput(event);
  }
  
  onArrivalDateSelect(selectedDate: Date): void {
    this.minDepartureDate = new Date(selectedDate);
    this.minDepartureDate = new Date(selectedDate);
    const selectedISO = selectedDate?.toISOString();
    const departureISO = new Date(this.itemForm.get('departureDate')?.value).toISOString();
    if (selectedISO === departureISO) {
      this.onDepartureDateSelect(selectedDate)

    }
    this.minDepartureDate.setHours(selectedDate.getHours() + 1);
  }

setDefaultDateMinutes(_event: any, controlName: string) {
    const currentValue = this.itemForm.get(controlName)?.value;
    const arrivalDate = this.itemForm.get('arrivalDate')?.value;
    const departureDate = this.itemForm.get('departureDate')?.value;
    let updatedDate: Date;
    if (currentValue) {
      if (controlName === 'departureDate') {
        if (arrivalDate) {
          this.onDepartureDateSelect(arrivalDate)
        }
      }

      if (arrivalDate && departureDate) {
        if ((departureDate <= arrivalDate)) {
          this.onDepartureDateSelect(arrivalDate);
        }
      }
      updatedDate = new Date(currentValue);
    } else if (controlName === 'arrivalDate') {
      updatedDate = new Date();
      updatedDate.setMinutes(0, 0, 0); 
      if (updatedDate === departureDate) {
        this.onDepartureDateSelect(updatedDate);
        this.itemForm.get('departureDate')?.setValue(this.itemForm.get('departureDate')?.value);
      }

    } else if (controlName === 'departureDate') {
      if (arrivalDate) {
        if (!departureDate) {
          this.onDepartureDateSelect(arrivalDate);
          this.itemForm.get('departureDate')?.setValue(this.itemForm.get('departureDate')?.value);
        }
      } else {
        updatedDate = new Date();
      }
    }

    updatedDate.setMinutes(0, 0, 0);
    this.itemForm.get(controlName)?.setValue(updatedDate);
    if (controlName === 'arrivalDate' && !currentValue) {
      this.onArrivalDateSelect(this.itemForm.get('arrivalDate')?.value);
    }
  }

  parseCustomDate(dateString: string): Date | null {
    const regex = /^([A-Za-z]{3})\s([A-Za-z]{3})\s(\d{2})\s(\d{4})\s(\d{2}):(\d{2}):(\d{2})\sGMT([+-]\d{4})\s\((.*?)\)$/;
    const match = dateString.match(regex);

    if (match) {
      const [_, day, month, date, year, hour, minute, second, timezoneOffset] = match;
      const formattedDate = `${month} ${date} ${year} ${hour}:${minute}:${second} GMT${timezoneOffset}`;
      return new Date(formattedDate);
    } else {
      return null;
    }
  }

  onDepartureDateSelect(arrivalDate: Date): void {
    const arrivalDateTime = new Date(arrivalDate);
    const adjustedDepartureDate = new Date(arrivalDate);
    adjustedDepartureDate.setHours(arrivalDateTime.getHours() + 1);
    adjustedDepartureDate.setMinutes(arrivalDateTime.getMinutes());
    this.itemForm.get('departureDate')?.setValue(adjustedDepartureDate);
  }

  validatePhoneNumber() {
    const phoneNumber = this.itemForm.get('phoneNumber')?.value?.e164Number;
    if (phoneNumber.invalid) {
      this.toastService.showToastMessage('error', 'Error', 'Please enter a valid mobile number.');
      return;
    }
    const req = { searchEmail: '', searchMobileNumber: phoneNumber };
    this.superAdminService.getUserByEmailId(req)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (res: any) => {
        this.driverId = res[0].id;
        this.getUserDetailById( this.driverId);
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.showToastMessage('error', 'Error', error.error.message);
        
      }
    });
  }
  onMobileTyping(_event) {
    this.itemForm.patchValue({
      name: '',
      email: ''
    });
  }
}